import { IHeiBuyboxState, IHeiBuyboxV2Data } from '../hei-buybox-v2.data';
import { IHeiBuyboxV2Props } from '../hei-buybox-v2.props.autogenerated';
import Price from './price';
import * as React from 'react';

export function getBuyboxProductPrice(props: IHeiBuyboxV2Props<IHeiBuyboxV2Data>, state: IHeiBuyboxState): React.ReactElement | undefined {
    const {
        id,
        typeName,
        context,
        resources,
        data: {
            attributeValues: { result: attributeValues }
        }
    } = props;

    return (
        state.productPrice && (
            <Price
                id={id}
                typeName={typeName}
                context={context}
                attributeValues={attributeValues}
                data={{ price: state.productPrice }}
                resources={resources}
                freePriceText={resources.priceFree}
                originalPriceText={resources.originalPriceText}
                currentPriceText={resources.currentPriceText}
            />
        )
    );
}
